import { KohostHTTPClient as Client } from "@kohost/api-client/client";
import { getApiUrl } from "lib/api/endpoints";
import { getOrganizationId } from "lib/api/organization";
import { constructEntity, constructError } from "./transforms";

const { VITE_AUTH_URL } = import.meta.env;

let organization = getOrganizationId();

if (organization === "auth") organization = null;

// if organization_id is in the url, use it
if (
  window.location.search.includes("organization_id") &&
  window.location.pathname === "/login"
) {
  const url = new URL(window.location.href);
  organization = url.searchParams.get("organization_id");
}

console.log("organization", organization);

const apiUrl = getApiUrl();

export const kohost = new Client({
  url: `${apiUrl}v3/`,
  organizationId: organization,
  onSuccess: (response) => {
    if (Array.isArray(response.data)) {
      response.data = response.data.map((responseData) => {
        try {
          if (!responseData) return responseData;
          return constructEntity(responseData);
        } catch (error) {
          console.error(error);

          return responseData;
        }
      });
    } else if (response.data?.type) {
      try {
        response.data = constructEntity(response.data);
      } catch (error) {
        console.error(error);
        if (error.cause) {
          console.error(error.cause);
        }
      }
    }

    return response;
  },
});

kohost.on("LoginRequired", () => {
  const authUrl = new URL(VITE_AUTH_URL);
  if (
    window.location.pathname !== "/login" &&
    window.location.origin !== authUrl.origin
  ) {
    authUrl.searchParams.set("redirect_uri", window.location.href);
    if (organization && organization !== "auth") {
      authUrl.searchParams.set("organization_id", organization);
    }
    console.log("login required redirecting to [kohost]", authUrl.toString());
    window.open(authUrl.toString(), "_self");
  }
});

export const PROPERTY_HEADER = Client.defs.propertyHeader;

/**
 *
 * @param {import('@tanstack/react-query').QueryFunctionContext} ctx
 */
export const getContextHeaders = (ctx) => {
  const client = ctx.client;
  const defaultOptions = client.getDefaultOptions();
  if (defaultOptions.queries?.meta?.headers) {
    return defaultOptions.queries.meta.headers;
  }
  return {};
};

export const setKohostPropertyId = (propertyId) => {
  kohost.propertyId = propertyId;
};

export const setKohostOrganizationId = (organizationId) => {
  if (kohost.organizationId !== organizationId) {
    console.log("setting organizationId", organizationId);
    kohost.organizationId = organizationId;
  }
};

/**
 *
 * @deprecated use sendRequest instead
 */
export function sendCommand(useCase, options = {}) {
  if (typeof useCase !== "object") throw new Error("useCase must be an object");

  return async function fetch() {
    try {
      const response = await kohost.send(useCase);
      const responseData = response.data;
      if (
        options.transformResponse &&
        typeof options.transformResponse === "function"
      ) {
        return options.transformResponse(responseData);
      }
      return responseData;
    } catch (error) {
      const exception = constructError(error);
      throw exception;
    }
  };
}

export async function sendRequest(useCase) {
  try {
    const response = await kohost.send(useCase);
    return response.data;
  } catch (error) {
    const exception = constructError(error);
    throw exception;
  }
}

export default kohost;
